import { render, staticRenderFns } from "./AddonJustGiving.vue?vue&type=template&id=02f3bb28&"
import script from "./AddonJustGiving.vue?vue&type=script&lang=js&"
export * from "./AddonJustGiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports